<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <h1>Pas de contenu ici</h1>
    </main>
</template>

<script>

</script>
